<template>
  <Modal
    @close="$emit('close')"
    title="Reporte mensual pendiente"
    classes="col-lg-5"
  >
    <div class="body my-1" slot="body">
      <div class="col-lg-6 mx-auto text-center">
        <p style="font-size: 25px">Tienes un reporte mensual pendiente</p>
      </div>
      <div class="col-lg-6 mx-auto text-center">
        <button class="button secondary" @click="$emit('showReport')">
          Ver
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
  name: "MonthlyModal",
  components: {
    Modal,
  },
  data() {
    return {
      showSpinner: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>
